import { render, staticRenderFns } from "./App-block-normal.vue?vue&type=template&id=5dfc8266&scoped=true&"
import script from "./App-block-normal.vue?vue&type=script&lang=ts&"
export * from "./App-block-normal.vue?vue&type=script&lang=ts&"
import style0 from "./App-block-normal.vue?vue&type=style&index=0&id=5dfc8266&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfc8266",
  null
  
)

export default component.exports